import { Cluster } from '@core/models';
/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2021. All Rights Reserved.
#*
#*===================================================================
*/

import { createAction, props } from '@ngrx/store';

export const loadClusters = createAction('[Settings:Clusters] Load Clusters');
export const loadClustersSuccess = createAction(
  '[Settings:Clusters] Load Custers Success',
  props<{ clusters: Cluster[] }>()
);
export const loadClustersFailure = createAction(
  '[Settings:Clusters] Load Clusters Failure',
  props<{ errorMessage: string }>()
);

export const addCluster = createAction('[Settings:Clusters] Add Cluster', props<{ cluster: Partial<Cluster> }>());
export const addClusterSuccess = createAction('[Settings:Clusters] Add Cluster success', props<{ cluster: Cluster }>());
export const addClusterFailure = createAction(
  '[Settings:Clusters] Add Cluster failure',
  props<{ errorMessage: string }>()
);

export const updateCluster = createAction('[Settings:Clusters] Update Cluster', props<{ cluster: Partial<Cluster> }>());
export const updateClusterSuccess = createAction(
  '[Settings:Clusters] Update Cluster success',
  props<{ cluster: Cluster }>()
);
export const updateClusterFailure = createAction(
  '[Settings:Clusters] Update Cluster failure',
  props<{ errorMessage: string }>()
);
